import { RecaptchaSiteVerifyResponse } from './recaptchaSiteVerifyResponse';

const mockData = {
  success: true,
};

export const RecaptchaSiteVerifyServiceMock: RecaptchaSiteVerifyResponse = {
  data: mockData,
  succeeded: true,
};
